import { ApolloError, useQuery } from '@apollo/client'
import { ExcecutedPaymentsByEmployeeIdQuery, ExcecutedPaymentsByEmployeeIdQueryVariables } from '../../../types'
import { EXECUTED_PAYMENTS_BY_EMPLOYEE_ID } from '../Queries'

export default (
  employeeId: string,
  resigned = false,
): { data: ExcecutedPaymentsByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    employeeResigned: resigned,
  }

  const { data, error, loading } = useQuery<ExcecutedPaymentsByEmployeeIdQuery, ExcecutedPaymentsByEmployeeIdQueryVariables>(
    EXECUTED_PAYMENTS_BY_EMPLOYEE_ID,
    {
      variables: variables,
    },
  )

  return { data, error, loading }
}
